<template lang="pug">
.generic-wrapper
  .left
    BackButton
    h1.title(v-if="!editHeadline" @click="editHeadline = true; tempName = formData.name") {{formData.name}}
    b-field(grouped v-else)
      b-input(v-model="tempName").title
      b-button(type="is-white" icon-left="chevron-triple-up" @click="addUpToHeadline()")
      .spacer.sm
      b-button(type="is-success" icon-left="content-save-outline" @click="updateHeadline()")
      .spacer.sm
      b-button(type="is-danger" icon-left="close" @click="editHeadline = false")
    .sub-headline Zuletzt bearbeitet am {{ formatDate(formData.updatedAt) }} Uhr | Wörter: {{wordCount}}
    
    .page-controls
      b-button(v-if="!formData.active" type="is-success" size="is-small" @click="publish()") Seite jetzt veröffentlichen
      b-button(v-if="formData.active" type="is-danger" size="is-small" @click="publish()") Seite jetzt offline nehmen
      template
        //- span(v-if="!dataChanged || new Date(formData.lastPublished).toISOString() === new Date(formData.updatedAt).toISOString() || new Date(formData.lastUnpublished).toISOString() === new Date(formData.updatedAt).toISOString()")
        span(v-if="!dataChanged")
        span(v-else)
          .spacer.sm.inline
          b-button(type="is-primary" size="is-small" @click="copyDraftToProd") Inhalte aktualisieren
          .spacer.sm.inline
          b-button(type="is-gray" size="is-small" @click="copyProdToDraft") Änderungen verwerfen
      .spacer.sm.inline
      a(:href="`${websiteUrl}/vorschau/${id}`" target="_blank")
        b-button(type="is-white" size="is-small" icon-left="open-in-new")

    .word-page.margin-top(v-if="formData && formData.draftContent && formData.draftContent.key && medias && blockModels")
      CMSBlockGroup(init, :initBlock="formData.draftContent" :parentKey="formData.draftContent.key")
      //- pre {{formData.draftContent}}
  .right(v-if="websiteUrl")
    iframe(ref="preview" :src="`${websiteUrl}/vorschau/${id}`" width="100%" height="960px")

    .bottom-float(:style="{bottom: saveTimer <= saveTimerWaitSeconds + 1 ? '40px' : '-60px'}")
      //- b-tag(v-if="formData.active" type="is-succcess") Veröffentlicht
      //- b-tag(v-else type="is-gray") Entwurf
      //- b-button(size="is-small" type="is-success" @click="autoSavePage") Veröffentlichen
      .saved(v-if="saveTimer >= saveTimerWaitSeconds") ✔ gespeichert
      .not-saved(v-else) ⌛ speichern...
      .auto-save-bar
        .auto-save-inner(:style="{width: saveTimer < saveTimerWaitSeconds ? (saveTimer*(100 / saveTimerWaitSeconds))+'%' : '100%'}")
</template>

<script>
import { v4 as uuidv4 } from 'uuid';
import { DateTime } from "luxon";
import CMSBlockGroup from '@/components/cms/BlockGroup.vue';

export default {
  components: {
    CMSBlockGroup
  },
  props: {
    id: {
      type: String || Number
    }
  },
  data() {
    return {
      tempName: "",
      editHeadline: false,
      wordCount: 0,
      dataChanged: false,
      saveTimer: 10,
      saveTimerWaitSeconds: 3,
      formData: {
        name: ""
      }
    };
  },
  computed: {
    websiteUrl() {
      return process.env.VUE_APP_WEBSITE;
    },
    blockModels() {
      return this.$store.state.blockModels.all;
    },
    medias() {
      return this.$store.state.medias.all;
    },
  },
  methods: {
    addUpToHeadline() {
      let match = this.tempName.match(/\((TOP 1)\)/);
      if (match) {
        this.tempName = this.tempName.replace('(TOP 1) ', "");
      } else {
        this.tempName = `(TOP 1) ${this.tempName}`;
      }
    },
    copyDraftToProd() {
      const _formDataContent = JSON.parse(JSON.stringify(this.formData.draftContent));
      this.$set(this.formData, 'content', _formDataContent);
      this.dataChanged = false;
      this.saveTimer = 0;
    },
    copyProdToDraft() {
      const _formDataContent = JSON.parse(JSON.stringify(this.formData.content));
      this.$set(this.formData, 'draftContent', _formDataContent);
      this.dataChanged = false;
      this.saveTimer = 0;
    },
    findNode(key, currentNode) {
      if (!currentNode.key) return false;

      let i,
          currentChild,
          result;

      if (key == currentNode.key) {
          return currentNode;
      } else {

          // Use a for loop instead of forEach to avoid nested functions
          // Otherwise "return" will not work properly
          if (!currentNode.blocks) return false;
          for (i = 0; i < currentNode.blocks.length; i += 1) {
              currentChild = currentNode.blocks[i];

              // Search in the current child
              result = this.findNode(key, currentChild);

              // Return the result if the node has been found
              if (result !== false) {
                  return result;
              }
          }

          // The node has not been found and we have no more options
          return false;
      }
    },
    createUniqueKeys(currentNode) {
      if (!currentNode.key) currentNode.key = uuidv4();

      let i,
          currentChild;

      // Use a for loop instead of forEach to avoid nested functions
      // Otherwise "return" will not work properly
      if (!currentNode.blocks) return false;
      for (i = 0; i < currentNode.blocks.length; i += 1) {
          currentChild = currentNode.blocks[i];
          currentChild.key = uuidv4();
          // Search in the current child
          this.createUniqueKeys(currentChild);
      }

      // The node has not been found and we have no more options
      return false;
    },
    countAllWordsInNode(currentNode, wordCount) {
      let i,
          currentChild;

      // Use a for loop instead of forEach to avoid nested functions
      // Otherwise "return" will not work properly
      if (!currentNode.blocks) return wordCount;
      for (i = 0; i < currentNode.blocks.length; i += 1) {
          currentChild = currentNode.blocks[i];
          if (currentChild && currentChild.value && currentChild.value.text) {
            wordCount += currentChild.value.text.split(' ').length;
          }
          // Search in the current child
          wordCount = this.countAllWordsInNode(currentChild, wordCount);
      }

      // The node has not been found and we have no more options
      return wordCount;
    },
    async mount() {
      const loadingComponent = this.$buefy.loading.open();

      await this.$store.dispatch("blockModels/findAll");
      await this.$store.dispatch("medias/findAll");

      if (this.$route.name === "CMSBlockEdit") {
        const block = await this.$store.dispatch("blocks/findOne", { id: this.id });
        this.formData = block;

        const _formDataContent = JSON.parse(JSON.stringify(this.formData.draftContent));
        this.wordCount = this.countAllWordsInNode(_formDataContent, 0);
      }
      loadingComponent.close();

      this.$root.$on('createBlockJSON', ({key, json, index}) => {
        const _formDataContent = JSON.parse(JSON.stringify(this.formData.draftContent));
        const node = this.findNode(key, _formDataContent);
        this.createUniqueKeys(json)
        node.blocks.splice(index, 0, json);
        this.$set(this.formData, 'draftContent', _formDataContent);
      });

      this.$root.$on('initBlockJSON', ({parentKey, name, key, blockModel}) => {
        const _formDataContent = JSON.parse(JSON.stringify(this.formData.draftContent));
        const node = this.findNode(parentKey, _formDataContent);
        for (let i = 0; i < node.blocks.length; i += 1) {
          if (node.blocks[i].name === name) {
            this.$set(node.blocks, i, {...blockModel, key});
            this.$set(this.formData, 'draftContent', _formDataContent);
          }
        }
      });

      this.$root.$on('justSave', () => {
        this.dataChanged = true;
        this.saveTimer = 0;
      });

      this.$root.$on('updateBlockJSON', ({parentKey, key, value}) => {
        const _formDataContent = JSON.parse(JSON.stringify(this.formData.draftContent));
        const node = this.findNode(parentKey, _formDataContent);
        for (let i = 0; i < node.blocks.length; i += 1) {
          if (node.blocks[i].key === key) {
            this.$set(node.blocks, i, {...node.blocks[i], value});
            this.$set(this.formData, 'draftContent', _formDataContent);
          }
        }
        this.dataChanged = true;
        this.saveTimer = 0;
      });

      this.$root.$on('removeBlockJSON', ({parentKey, key}) => {
        const _formDataContent = JSON.parse(JSON.stringify(this.formData.draftContent));
        const node = this.findNode(parentKey, _formDataContent);

        let deleteIndex = null;
        for (let i = 0; i < node.blocks.length; i += 1) {
          if (node.blocks[i].key === key) {
            deleteIndex = i;
            break;
          }
        }

        if (deleteIndex !== null) {
          node.blocks.splice(deleteIndex, 1);
          this.$set(this.formData, 'draftContent', _formDataContent);
          this.saveTimer = 0;
        }
      });

      this.$root.$on('repositionBlockJSON', ({parentKey, key, direction}) => {
        const _formDataContent = JSON.parse(JSON.stringify(this.formData.draftContent));
        const node = this.findNode(parentKey, _formDataContent);

        let currentIndex = null;
        for (let i = 0; i < node.blocks.length; i += 1) {
          if (node.blocks[i].key === key) {
            currentIndex = i;
            break;
          }
        }

        if (currentIndex !== null) {
          if (direction === 'up' && node.blocks[currentIndex - 1]) {
            const copy = JSON.parse(JSON.stringify(node.blocks[currentIndex]));
            node.blocks.splice(currentIndex, 1);
            node.blocks.splice(currentIndex - 1, 0, copy);
          } else if (direction === 'down' && node.blocks[currentIndex + 1]) {
            const copy = JSON.parse(JSON.stringify(node.blocks[currentIndex]));
            node.blocks.splice(currentIndex + 2, 0, copy);
            node.blocks.splice(currentIndex, 1);
          }
      
          this.$set(this.formData, 'draftContent', _formDataContent);
          this.saveTimer = 0;
        }
      });
    },
    formatDate(d) {
      const dt = DateTime.fromISO(d);
      return dt.toLocaleString({
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
      });
    },
    async autoSavePage() {
      await this.$store.dispatch("blocks/update", this.formData);
      this.$refs.preview.src = this.$refs.preview.src + "";
      
      const _formDataContent = JSON.parse(JSON.stringify(this.formData.draftContent));
      this.wordCount = this.countAllWordsInNode(_formDataContent, 0);
    },
    async publish() {
      await this.$store.dispatch("blocks/updateActive", this.formData);
      const loadingComponent = this.$buefy.loading.open();

      if (this.$route.name === "CMSBlockEdit") {
        const block = await this.$store.dispatch("blocks/findOne", { id: this.id });
        this.formData = block;
      }

      loadingComponent.close();
    },
    async updateHeadline() {
      this.formData.name = this.tempName;
      await this.$store.dispatch("blocks/update", this.formData);
      this.editHeadline = false;
    }
  },
  mounted() {
    this.mount();
    setInterval(() => {
      this.saveTimer += 0.1;
      if (this.saveTimerWaitSeconds <= this.saveTimer && this.saveTimerWaitSeconds + 1 > this.saveTimer) {
        this.autoSavePage();
        this.saveTimer += 10;
      }
    }, 100);
  },
  beforeDestroy() {
    // Destroy all listeners
    this.$root.$off();
  }
}
</script>

<style lang="scss" scoped>

.generic-wrapper {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  padding-bottom: 320px;
  .left {
    width: 50%;
  }
  .right {
    position: fixed;
    right: 0;
    top: 0px;
    width: calc(50vw - 40px);
    height: 100vh;
    background-color: white;
    border-left: 1px black solid;
  }
}
.word-page {
  background-color: white;
  padding: 16px 16px;
}

.auto-save-bar {
  margin-top: 4px;
  background-color: rgb(194, 255, 194);
  width: 106px;
  height: 6px;

  .auto-save-inner {
    height: 100%;
    background-color: green;
    transition: width 0.2s ease;
  }
}

.bottom-float {
  transition: all 0.2s ease;
}

.saved {
  font-size: 0.8rem ;
}
.not-saved {
  font-size: 0.8rem ;
}

.page-controls {
  margin-top: 16px;
}
</style>